export default __webpack_public_path__ + "static/media/hf3.50b152e7.svg";